// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/es6.object.get-own-property-names.js
// module id = 84
// module chunks = 0